export default __webpack_public_path__ + "static/1-37-0-configurable-columns-eb6e117b828f67b69ccc49515d5818d3.png";